import React, { useEffect, useRef, useState } from "react";

import { useAppContext } from "../context/AppContext";
import { basePath, nonStandardColors, standardColors } from "../lib/constant";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowLeft,

} from "@fortawesome/pro-solid-svg-icons";

import { cn } from "../lib/utils";

import { useFormContext } from "react-hook-form";
import { buttonVariants } from "../components/Configurator/ui/Button";
import TradeForm from "../components/Configurator/forms/TradeForm";
import QuoteForm from "../components/Configurator/forms/QuoteForm";
import SummaryList from "./summary/SummaryList";
import ConfiguredDoor from "../components/Configurator/scene/ConfiguredDoor";
import DoorView from "../components/Configurator/scene/DoorView";

const Summary = ({ methods, type }) => {
    const isTrade = type === 'trade';

    const doorSvgRef = useRef(null);
    const { getValues ,watch} = useFormContext();
    const {
        external_door_style,
        external_door_colour,
        internal_door_colour,
        external_handle_style,
    } = getValues();



    const [colourArray, setColourArray] = useState(standardColors);

    const { state, setCurrentPage } = useAppContext();
    const { view, selectedColourType, selectedExternalColourType } = state;
    const configuration = watch("configuration");
    const openingDirection = watch("opening_direction");
    const eKeyEntry = watch("e_key_entry");
    const hasTopbar = type !== "trade";
    const [mobileDetailsVisible, setMobileDetailsVisible] = useState(true);

    useEffect(() => {
        selectedExternalColourType === "standard"
            ? setColourArray(standardColors)
            : setColourArray(nonStandardColors);
    }, [selectedExternalColourType]);

    const externalSelectedColour = colourArray.find(
        (item) => item.code === external_door_colour
    );
    const internalSelectedColour = colourArray.find(
        (item) => item.code === internal_door_colour
    );

    const handleSaveForLater = () => {
        if (typeof window === "undefined") {
            return;
        }
        window.print();
    };

    const currentDate = new Date().toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    return (
        <section className={cn(
                "bg-[#424242] h-auto md:h-screen overflow-y-auto md:overflow-hidden summary-page",
                hasTopbar && "md:h-[calc(100vh-120px)]"
            )}>
            {/* ── PDF Header (print only) ── */}
            <div className="pdf-header print-only" style={{ display: 'none' }}>
                <div className="pdf-header-logo">
                    <img src="/assets/rhinologoblack.png" alt="Rhino Door" />
                </div>
                <div className="pdf-header-info">
                    <div className="pdf-title">Configuration Summary</div>
                    <div className="pdf-date">{currentDate}</div>
                    <div>hello@rhinodoor.co.uk &middot; 01843 446679</div>
                    <div>www.rhinodoor.co.uk</div>
                </div>
            </div>

            <div className="flex flex-col md:flex-row h-full min-h-0 summary-layout">
                <div className="grid grid-cols-1 md:grid-cols-2 h-full min-h-0 divide-x divide-gray-50/70 gap-6 flex-1 overflow-hidden summary-grid">
                    <div className="flex flex-col py-12 px-6 min-h-0 summary-left">
                        <h2 className="text-white text-2xl md:text-3xl uppercase summary-page-title">
                            configuration summary
                        </h2>
                        <div className="relative flex-1 min-h-[50vh] md:min-h-0 w-full flex flex-col summary-door print-avoid-break">
                            <div className="no-print flex-1 min-h-0 w-full flex flex-col bg-[#eeecea] rounded-lg overflow-hidden">
                                <DoorView/>
                                <svg
                                    ref={doorSvgRef}
                                    className="bg-[#eeecea] w-full h-full flex-1 object-contain"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    viewBox="900 150 2000 2500"
                                    preserveAspectRatio="xMidYMid meet"
                                >
                                    <ConfiguredDoor translate='translate(1200,375)'/>
                                </svg>
                            </div>

                            <div className="print-only summary-door-print-grid">
                                <div className="summary-door-print-col">
                                    <h3 className="summary-door-print-title">External</h3>
                                    <svg
                                        className="bg-white w-full h-auto"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        viewBox="400 0 2840 2800"
                                    >
                                        <ConfiguredDoor translate='translate(1200,375)' viewOverride="external"/>
                                    </svg>
                                </div>
                                <div className="summary-door-print-col">
                                    <h3 className="summary-door-print-title">Internal</h3>
                                    <svg
                                        className="bg-white w-full h-auto"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        viewBox="400 0 2840 2800"
                                    >
                                        <ConfiguredDoor translate='translate(1200,375)' viewOverride="internal"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-wrap items-center gap-4 pt-4 no-print flex-shrink-0 relative z-10">
                            <button
                                className={buttonVariants({
                                    className: "uppercase w-fit flex gap-6",
                                    variant: "basic",
                                })}
                                onClick={() => setCurrentPage("home")}
                                type="button"
                            >
                                <FontAwesomeIcon icon={faArrowLeft}/>
                                back to configuration mode
                            </button>

                            <button
                                className={buttonVariants({
                                    className: "uppercase w-fit",
                                    variant: "default",
                                })}
                                onClick={handleSaveForLater}
                                type="button"
                            >
                                Save for later (PDF)
                            </button>
                        </div>
                    </div>

                    <div className="min-h-0 overflow-hidden summary-list-wrapper">
                        {/* Page 2 title for print */}
                        <div className="pdf-page2-title print-only" style={{ display: 'none' }}>
                            Configuration Details
                        </div>
                        <SummaryList type={type} hidePrices/>
                    </div>
                </div>
                {/* form value */}

                <div className="w-full md:w-[30%] h-full min-h-0 bg-white shadow-md overflow-hidden no-print summary-form">
                    {type === "trade" ? (
                        <TradeForm type={type} methods={methods} doorSvgRef={doorSvgRef} />
                    ) : (
                        <QuoteForm methods={methods} doorSvgRef={doorSvgRef} />
                    )}
                </div>
            </div>

            {/* ── PDF Footer (print only) ── */}
            <div className="pdf-footer print-only" style={{ display: 'none' }}>
                <div>Rhino Door &middot; Unit 1, Manston Business Park, Ramsgate, Kent CT12 5FN</div>
                <div>
                    <a href="https://www.rhinodoor.co.uk">www.rhinodoor.co.uk</a> &middot;
                    <a href="mailto:hello@rhinodoor.co.uk">hello@rhinodoor.co.uk</a> &middot;
                    01843 446679
                </div>
                <div style={{ marginTop: '2mm', fontSize: '7px' }}>
                    This document was generated on {currentDate}. Configuration details are subject to final confirmation.
                </div>
            </div>
        </section>
    );
};

export default Summary;
